import splitSvg from 'assets/icons/split.svg';
import Modal from 'lib/Modal';
import Button, { Color, Size } from 'lib/Button';

interface Props {
  isLiveLineModalVisible: boolean;
  setShowLiveLineModal: (state: boolean) => void;
  handleUpdateLiveLine: () => void;
}

const LiveLineDialog = ({
  isLiveLineModalVisible,
  setShowLiveLineModal,
  handleUpdateLiveLine,
}: Props): React.ReactElement => {
  return (
    <Modal
      isOpen={isLiveLineModalVisible}
      icon={splitSvg}
      title="Live Line"
      actionButtons={
        <>
          <Button color={Color.DANGER} size={Size.LARGE} onClick={() => setShowLiveLineModal(false)} label="Cancel" />
          <Button color={Color.PRIMARY} size={Size.LARGE} onClick={handleUpdateLiveLine} label="Confirm" />
        </>
      }
    >
      <div className="ml-8 body-base text-neutral-950-opacity-60">
        <p className="mb-4">
          Saving these changes will cause this line to split. The previous delivery will stop and go into a Terminated
          status when these changes go live.
        </p>
        <p>Do you want to continue and split the line?</p>
      </div>
    </Modal>
  );
};

export default LiveLineDialog;
